export var ERROR_ACTIONS={SHOW_ERROR_MODAL:'SHOW_ERROR_MODAL',HIDE_ERROR_MODAL:'HIDE_ERROR_MODAL'};